import { useContext } from 'react';
import { TagContext } from 'tags/context/tagContext';

export const useTagsContext = () => {
  return useContext(TagContext);
};
